import { render, staticRenderFns } from "./ScopedLoadingOverlay.vue?vue&type=template&id=ef466442"
import script from "./ScopedLoadingOverlay.vue?vue&type=script&lang=js"
export * from "./ScopedLoadingOverlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports